// Mega menu
function megamenuFunction(event, menu_name) {
  // [...document.querySelectorAll('nav.megamenu')].forEach(function (item) {
  //   var nav_megamenu_title = item.getAttribute('data_menu');
  //   if( menu_name == nav_megamenu_title ){
  //     item.classList.add('active');
  //   }else{
  //     item.classList.remove('active');
  //   }
  // });  

  console.log(menu_name);

  var topMenuElement = document.querySelectorAll("nav.megamenu");
  var mainNavElements = document.querySelectorAll(".topmenu li");
  for (var i = 0; i < topMenuElement.length; i++) {
    var nav_megamenu_title = mainNavElements[i].getAttribute('data-name');
    var topMenuElement_title = topMenuElement[i].getAttribute('data_menu');
    console.log("data menu = "+topMenuElement[i].getAttribute('data_menu'));
    // console.log(topMenuElement_title);

    if (menu_name == nav_megamenu_title) {
      mainNavElements[i].classList.add('active');
    } else {
      mainNavElements[i].classList.remove('active');
    }

    if (menu_name == topMenuElement_title) {
      topMenuElement[i].classList.add('active');
    } else {
      topMenuElement[i].classList.remove('active');
    }
  }
}


function drawer_menuFunction(event, menu_name) {
console.log(menu_name);


var triggersiblings = document.querySelector('#trigger___'+menu_name).parentNode.children;
for (var k = 0; k < triggersiblings.length; k++) {
  if (triggersiblings[k] !== this) {
    triggersiblings[k].classList.remove('active');
  }
}
document.querySelector('#trigger___'+menu_name).classList.add('active');

 // Remove class from siblings
 var siblings = document.querySelector('#mobile_'+menu_name).parentNode.children;
 for (var j = 0; j < siblings.length; j++) {
   if (siblings[j] !== this) {
     siblings[j].classList.remove('active');
   }
 }
 document.querySelector('#mobile_'+menu_name).classList.add('active');
}






// quiz page
// function quizFunction() {
//   document.querySelector('.page-content-wraper').classList.add('hide');
//   document.querySelector('.trigger-class').classList.add('active');
// }
// function backFunction() {
//   document.querySelector('.page-content-wraper').classList.remove('hide');
//   document.querySelector('.trigger-class').classList.remove('active');
// }



// footer accordion
[...document.querySelectorAll('.footer-block__heading')].forEach(function (item) {
  item.addEventListener('click', function () {
    item.classList.toggle('footer-accordion');
    item.nextElementSibling.classList.toggle('footer-accordion-active');
  });
});



// close function
function closeFunction() {
  const nodeList = document.querySelectorAll('.right-side-drawer');
    for (let i = 0; i < nodeList.length; i++) {
      nodeList[i].classList.remove('active');
    }
    document.body.classList.remove('overflow-hidden');  
  console.log('close click');
}